export enum ReportDataOption {
  DATA_OPTION_1 = 'DATA_OPTION_1',
  DATA_OPTION_2 = 'DATA_OPTION_2',
  DATA_OPTION_3 = 'DATA_OPTION_3',
  DATA_OPTION_4 = 'DATA_OPTION_4',
  DATA_OPTION_5 = 'DATA_OPTION_5',
  DATA_OPTION_6 = 'DATA_OPTION_6',
  DATA_OPTION_7 = 'DATA_OPTION_7',
  DATA_OPTION_8 = 'DATA_OPTION_8',
}

export enum InsightsReportType {
  PERFORMANCE = 'performance',
  OPERATIONS = 'operations',
  RATINGS = 'ratings',
  SETTLEMENTS = 'settlements',
}

export enum DataAggregationLevel {
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
  HOURLY = 'hourly',
}

export enum ReportFrequency {
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
}

// forms

export type ReportDataOptionForm = {
  dataOptions: ReportDataOption[];
};

export type InsightReportForm = {
  type: InsightsReportType;
  dataAggregationLevel: DataAggregationLevel;
  reportFrequency: ReportFrequency[];
  venueIds: string[];
} & ReportDataOptionForm;
